export const mailBoxApi = {
    getIncomingMail: 'v1/api/userMailMaster/incoming-email/mail',
    getMailDetailsById: 'v1/api/userMailMaster/incoming-email/mailDetails',
    sendMail: 'v1/api/userMailMaster/incoming-email/sendmail',
    bulkUpdate: 'v1/api/userMailMaster/incoming-email/updateMail?',
    assignMail: 'v1/api/incoming-email?',
    getMailsByAppId: 'v1/api/mailCommunication?applicationId=',
    updateCommunicationMail: 'v1/api/mailCommunication?mailCommunicationId=',
    getDashboardCounts: 'v1/api/userMailMaster/incoming-email/dashboard',
    getDashboardCountsV2: 'v2/api/userMailMaster/incoming-email/dashboard',
    downloadMail:
        'v1/api/userMailMaster/incoming-email/downloadEmail?messageId=',
    uploadMail: 'v1/api/incoming-email/pdfAndUpload',
    updateRead: 'v1/api/userMailMaster/incoming-email/readMail?Id=',
    mailRecieveWebhook: 'v1/api/userMailMaster/incoming-email/receive-webhook',
    createFolder: 'v1/api/users/update?Id=',
    addNewMailFolder: 'v1/api/domainMailFolders',
    saveDrafts: 'v1/api/userMailMaster/incoming-email/saveDrafts',
    getCalenderEvents: 'v1/api/userMailCalendar',
    mailRule: 'v1/api/userMailMasterRules',
    updateMailRule: 'v1/api/userMailMaster/incoming-email/updateMailWithRule',
};
